import type { RouteRecordRaw } from "vue-router";

export const resultRoutes: RouteRecordRaw[] = [
  {
    path: "/403",
    name: "Forbidden",
    component: () => import("@/pages/result/ForbiddenPage.vue"),
    meta: { title: "无权限" },
  },
  {
    path: "/500",
    name: "ServerError",
    component: () => import("@/pages/result/ServerErrorPage.vue"),
    meta: { title: "服务器错误" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/pages/result/NotFoundPage.vue"),
    meta: { title: "页面不存在" },
  },
];
